import React, { useContext, useState, useEffect } from 'react';
import '../../App.css'
import { Button, Container, List, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import TextField from '@mui/material/TextField';
import api from '../../connection/Axios';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { useLocation } from 'react-router-dom'


const AdicionarNr = ({ router }) => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [number, setNumber] = useState(0)
  const [name, setName] = useState('')
  const [shortDescription, setShortDescription] = useState('')
  const [documento, setDocumento] = useState('')
  const [items, setItems] = useState([])
  const [success, setSuccess] = useState(false)
  const [zeradoc, setZeradoc] = useState(false)
  const location = useLocation()
  const { dados } = location.state || []
  const [isEdit, setIsEdit] = useState(false)
  const [openEditNr, setOpenEditNr] = useState(false)
  const [openIndexNr, setOpenIndexNr] = useState(0)
  const [newDocumento, setNewDocumento] = useState('')
  

  useEffect(()=>{
    if(dados != undefined) {
      setNumber(dados.number)
      setName(dados.name)
      setShortDescription(dados.shortDescription)
      setItems(dados.items)
      setIsEdit(true)
    }
  }, [])

  console.log(dados)

  useEffect(()=>{
    setDocumento('')
  }, [zeradoc])

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

  const data = {
    "number": number,
    "name": name,
    "shortDescription": shortDescription,
    "items": items
  }

  function AddItems(value){
    setItems(items=>[...items, {documento: value}])
    setZeradoc(!zeradoc)
  }

  function updateItem(index) {
    setItems(items =>
      items.map((item, i) =>
        i === index ? { ...item, documento: newDocumento } : item
      )
    )
    setOpenEditNr(!openEditNr)
  }

  function Reset() {
    setName()
    setNumber()
    setShortDescription()
    setItems()
    setSuccess(true)
  }

  function CheckData(){
    if (name != '' && number != 0 && shortDescription != '') {
      if (items.length != 0) {
        SaveNr()
      } else {
        setSystemData({...systemData, erro: 'Ao menos um documento é obrigatório', typeError: 'warning'})
      }
    } else {
      setSystemData({...systemData, erro: 'Todos os campos são obrigatórios', typeError: 'warning'})
    }
  }

  async function SaveNr() {
    await api.post('nr/nr/', data, headers).then(response => {
      console.log(JSON.stringify(response.data))
      setSuccess(false)
      Reset()
    }).catch(error => {
      setSystemData({...systemData, erro: error.message, typeError: 'warning'})
    })
  }


  async function EditNr() {
    await api.put('nr/updateNr/', data, headers).then(response => {
      setSuccess(false)
      Reset()
    }).catch(error => {
      setSystemData({...systemData, erro: error.message, typeError: 'warning'})
    })
  }

function EditingNr(index) {
  setOpenEditNr(!openEditNr)
  setOpenIndexNr(index)
}


  return (
    <>
        <Layout breadcrumb='Dashboard / Normas Regulamentadoras / Adicionar Norma' title='Adicionar Norma'>
          <Typography>Preencha os campos abaixo para adicionar uma nova NR</Typography>
          <br />
          {!success ?
          <>

            <div style={styles.block}></div>
            <TextField  onChange={(event) => setNumber(event.target.value)} value={number} label="Número da NR" variant="outlined" style={{width: 100}} />
            
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setName(event.target.value)} value={name} label="Nome" variant="outlined" style={{width: '100%'}} />
            
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setShortDescription(event.target.value)} value={shortDescription} label="Descrição Rápida" variant="outlined" style={{width: '100%'}} />
            
            <div style={{marginBlock: 15}}></div>

            <span style={{fontWeight: 600}}>Documentos: </span> 
              <div style={{marginBottom: 15}}>
                {items?.map((item, index)=>(
                  <div key={index}>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: '#ffffff', justifyContent: 'space-between' ,width: 'auto', padding: 10, marginBottom: 5, borderRadius: 5}}>
                      <div>
                        {index+1} - {item.documento}
                      </div>
                      <Button variant="outlined" disableElevation color="warning" size="small" style={{marginLeft: 10}} onClick={()=>{EditingNr(index)}}>
                        Editar NR
                      </Button>
                    </div>
                      {openEditNr && openIndexNr === index ?
                          <div style={{marginTop: 10}}>
                            <TextField onChange={(e) => setNewDocumento(e.target.value)} value={newDocumento} label="Editar Documento" variant="outlined" style={{width: '100%'}} />
                            <Button onClick={()=>{updateItem(index)}} variant='contained' disableElevation size='medium' color='warning' style={{marginTop: 10, marginBottom: 15}}>Salvar</Button>
                          </div>
                      : null}
                  </div>  
                ))}
              </div>
            <div style={styles.block}></div>
            <div style={{marginBottom: 10}}>
              {isEdit ? 'Caso queira adicionar mais algum documento, preencha o campo abaixo:' : 'Adicione os documentos necessários para a conformidade com a NR cadastrada.'}
            </div>
            <TextField  onChange={(event) => {setDocumento(event.target.value)}} value={documento} label="Documento" variant="outlined" style={{width: '100%'}} />
            <div style={{marginBottom: 20, marginTop: 10}}>
              <Button variant="contained" color='secondary' className='boto' style={{color: '#ffffff'}} onClick={()=>{AddItems(documento)}}>
                Adicionar Documento
              </Button>
            </div>
            <div style={styles.block}></div>
            <div style={styles.block}>
              <Button variant="contained" className='boto' style={{color: '#ffffff'}} onClick={()=>{isEdit ? EditNr() : CheckData()}}>
                Salvar Norma
              </Button>
            </div>
          </>  
          :
          <>
            <div style={styles.block}></div>
            {isEdit ? 'Norma Regulamentadora editada com sucesso.' : 'Norma Regulamentadora criada com sucesso.'}
            <div style={styles.block}></div>
            
            <div style={styles.block}></div>
            <div style={styles.block}></div>
            <Button variant="contained" className='boto' style={{color: '#ffffff'}} onClick={()=>{Reset()}}>
              Cadastrar nova NR
            </Button>
          </>
          }
        </Layout>
    </>
  );
};

export default AdicionarNr


const styles = {
  block: {
    marginTop: 10,
  }
}